<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';
import { useMapGetter } from 'dashboard/composables/store';
import { inboxOwnerName } from 'dashboard/constants/inboxOwnerMap';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/no-unused-properties
  active: {
    type: Boolean,
    default: false,
  },
  inbox: {
    type: Object,
    required: true,
  },
  badgeCount: {
    type: [Number, String],
    default: 0,
  },
});

const agents = useMapGetter('agents/getAgents');

// 动态: 按 created_by_id(创建者=归属客服)从 agents store 解析名字;
// 解析不到退回 inboxOwnerMap 兜底, 再退回 label(收件箱名)。新加 inbox 无需改代码。
const displayName = computed(() => {
  const creator = props.inbox.created_by_id;
  const byCreator =
    creator && agents.value
      ? agents.value.find(a => a.id === creator)?.name
      : '';
  return byCreator || inboxOwnerName(props.inbox.id) || props.label;
});

const reauthorizationRequired = computed(() => {
  return props.inbox.reauthorization_required;
});
</script>

<template>
  <span class="size-4 grid place-content-center rounded-full">
    <ChannelIcon :inbox="inbox" class="size-4" />
  </span>
  <div class="flex-1 truncate min-w-0">{{ displayName }}</div>
  <SidebarUnreadBadge :count="badgeCount" />
  <div
    v-if="reauthorizationRequired"
    v-tooltip.top-end="$t('SIDEBAR.REAUTHORIZE')"
    class="grid place-content-center size-5 bg-n-ruby-5/60 rounded-full"
  >
    <Icon icon="i-woot-alert" class="size-3 text-n-ruby-9" />
  </div>
</template>
